<template>
  <div class="svgPlot-div">
    <div class="search-top">
      <el-input size="small" placeholder="快速搜索" v-model="filterText"> </el-input>
    </div>
    <div class="tree-content">
      <el-tree :default-expanded-keys="defaultExpandedCids" @node-click="nodeClick" :filter-node-method="filterNode"
        :data="treeData" node-key="title" ref="tree" highlight-current :props="defaultProps">
      </el-tree>
    </div>

    <div v-show="pics.length > 0" class="wrapper">
      <div v-for="(item, index) in pics" class="item">
        <el-tooltip>
          <div slot="content">名称：{{ item.name }}<br />编码：{{ item.code }}</div>
          <!-- <el-image @click="drawImg(item)" :src="item.url" :fit="fit"></el-image> -->
          <el-image :src="require(`../../components/SvgPlot/icons/${item.path}`)" @click="drawImg(item)"
            :fit="fit"></el-image>
        </el-tooltip>
      </div>
    </div>
  </div>
</template>
<script>
import { getCommonAjax } from "@/api/common.js";
import DragTool from "./dragTool.js";
let graphicLayer = null;
let rotationEnity = null;
let dragToolUit = null;
let graphicEnity = null;
let draggersEnityArr = null;
import svgEdit from "./svgEdit.vue";
import DrawRectangle3 from "@/utils/cesiumBD/plot2.0/rectangle/DrawRectangle"
var drawSvgTool = undefined;
import PlotManage from "@/utils/cesiumBD/plot/PlotManage.js";
let plotUti = undefined;
import tree from "./tree.json"
export default {
  data() {
    return {
      fit: "fill",
      pics: [],
      filterText: "",
      treeData: [],
      defaultExpandedCids: ["军队标号"],
      defaultProps: {
        children: "children",
        label: "title",
      },
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  async created() {
    var base = location.origin;
    const res = await getCommonAjax(base + "data/dirTree.json");
    this.treeData = res;
  },
  mounted() {
    // graphicLayer = new BD3d.layer.GraphicLayer({
    //   hasEdit: true,
    // });
    // map.addLayer(graphicLayer);
    // dragToolUit = new DragTool({
    //   viewer: viewer,
    //   pickfun: this.pickfun,
    //   movefun: this.movefun,
    // });
    // rotationEnity = viewer.entities.add({
    //   name: "旋转点",
    //   position: Cesium.Cartesian3.fromDegrees(0, 0),
    //   point: {
    //     color: Cesium.Color.SKYBLUE,
    //     pixelSize: 10,
    //     outlineColor: Cesium.Color.YELLOW,
    //     outlineWidth: 3,
    //     disableDepthTestDistance: Number.POSITIVE_INFINITY,
    //     heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
    //   },
    // });
    // rotationEnity.show = false;
    // this.$bus.$on("saveAttr", (url) => {
    //   graphicEnity.setStyle({
    //     image: url,
    //   });
    // });
    if (!plotUti) {
      plotUti = new PlotManage({});
    }

    plotUti.onDbclick(this.dbclick);
  },
  beforeDestroy() {
    // this.$bus.$off("saveAttr");
    // graphicLayer && graphicLayer.clear();
    plotUti.removeDbclick();
    drawSvgTool = undefined;
  },
  methods: {
    getPickEnity(pick) {
      if (Cesium.defined(pick) && (pick.id)) {
        return pick.id;
      }

      return null;
    },
    dbclick(evt) {
      var ins = this.$dialog.getDialog("矢量标绘");
      if (ins) {
          return;
      }
      let pick = viewer.scene.pick(evt.position);
      var entity = this.getPickEnity(pick);
      // entity.extTag = "BH_Feature";
      if (entity && entity.extTag && entity.extTag == "BH_Feature") {
        this.$confirm("是否删除该矢量标绘？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {

            if (entity.attrPlot && entity.attrPlot["edit_keyPos"]) {
              let entities = entity.attrPlot["edit_keyPos"];
              for (let i = 0; i < entities.length; i++) {
                viewer.entities.remove(entities[i]);
              }
            }

            if (entity.attrPlot && entity.attrPlot["edit_center"]) {
              let entities = [entity.attrPlot["edit_center"]];
              for (let i = 0; i < entities.length; i++) {
                viewer.entities.remove(entities[i]);
              }
            }

            if (entity.attrPlot && entity.attrPlot["edit_rotation"]) {
              let entities = [entity.attrPlot["edit_rotation"]];
              for (let i = 0; i < entities.length; i++) {
                viewer.entities.remove(entities[i]);
              }
            }

            if (entity.attrPlot && entity.attrPlot["edit_height"]) {
              let entities = [entity.attrPlot["edit_height"]];
              for (let i = 0; i < entities.length; i++) {
                viewer.entities.remove(entities[i]);
              }
            }

            viewer.entities.remove(entity); //自身

          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: "info",
              message: "本次操作已取消！",
              duration: 3 * 1000,
            });
          });

      }
    },
    drawImg(item) {
      var img = require(`../../components/SvgPlot/icons/${item.path}`);// item.url;
      if (!drawSvgTool) {
        drawSvgTool = new DrawRectangle3({ canEdit: true });
      }

      drawSvgTool.reset();
      drawSvgTool.start({
        style: {
          material: img,
        },
      }
      );

      // BD3d.DrawUtil.setPointStyle({
      //   pixelSize: 10,
      //   outlineColor: Cesium.Color.YELLOW,
      //   outlineWidth: 3,
      //   disableDepthTestDistance: Number.POSITIVE_INFINITY,
      //   heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
      //   outline: true,
      //   scaleByDistance: false,
      // });
      // var img = item.url;
      // graphicLayer.startDraw({
      //   type: "rectangle",
      //   style: {
      //     image: img,
      //     clampToGround: true,
      //   },
      //   attr: {
      //     image: img,
      //   },
      //   success: this.drawEnity,
      // });
    },
    pickfun(enity) {
      if (
        enity &&
        enity.position &&
        typeof enity.position.getValue == "function" &&
        enity.name === "旋转点"
      ) {
        enity.startPoint = enity.position.getValue();
        return true;
      }
      return false;
    },
    movefun(pick, cartesian) {
      //var coordinates = graphicEnity.coordinates;
      rotationEnity.position.setValue(cartesian);
      var startPoint = rotationEnity.startPoint;
      var endPoint = cartesian;
      var center = graphicEnity.center; // Cesium.Cartesian3.fromDegrees((coordinates[0][0] + coordinates[1][0]) / 2, (coordinates[0][1] + coordinates[1][1]) / 2);
      var angle1 = BD3d.MeasureUtil.getAngle(center, startPoint);
      var angle2 = BD3d.MeasureUtil.getAngle(center, endPoint);
      graphicEnity.setStyle({
        rotation: Cesium.Math.toRadians(angle1 - angle2),
        stRotation: Cesium.Math.toRadians(angle1 - angle2),
      });
    },
    drawEnity(g) {
      graphicEnity = g;
      draggersEnityArr = graphicEnity.editing.draggers;
      console.log(graphicEnity);
      //  [110.163758, 19.959662, 0]
      //  [110.165425, 19.957109, 0]
      var coordinates = g.coordinates;
      var isEditing = g.isEditing;
      var position = Cesium.Cartesian3.fromDegrees(coordinates[1][0], coordinates[0][1]);
      if (isEditing) {
        dragToolUit.startDrag();
        rotationEnity.show = true;
        rotationEnity.position.setValue(position);
      }

      //绑定监听事件
      g.on(BD3d.EventType.editMouseMove, function (event) {
        var graphic = event.graphic;
        var coordinates = graphic.coordinates;
        var isEditing = graphic.isEditing;
        var position = Cesium.Cartesian3.fromDegrees(
          coordinates[1][0],
          coordinates[0][1]
        );
        if (isEditing) {
          rotationEnity.position.setValue(position);
        }
      });

      g.on(BD3d.EventType.editStart, function (event) {
        var graphic = event.graphic;
        var coordinates = graphic.coordinates;
        var position = Cesium.Cartesian3.fromDegrees(
          coordinates[1][0],
          coordinates[0][1]
        );
        rotationEnity.position.setValue(position);
        rotationEnity.show = true;
        graphicEnity = graphic;
      });

      g.on(BD3d.EventType.editStop, function (event) {
        rotationEnity.show = false;
      });

      var that = this;
      g.on(BD3d.EventType.click, function (event) {
        var dialog = that.$dialog.getDialog("标绘");
        if (dialog) {
          that.$dialog.close(dialog);
        }
        that.$dialog.open({
          id: "标绘",
          title: "属性编辑",
          area: {
            height: "880px",
            width: "300px",
          },
          location: {
            top: undefined,
            left: undefined,
            bottom: "0",
            right: "0",
          },
          content: {
            type: "vue",
            subCom: svgEdit,
            subData: {
              image: g.attr.image,
            },
          },
        });
      });
    },
    nodeClick(item, node, el) {

      this.pics = [];
      //叶子节点
      if (!item.children || item.children.length < 1) {
        var file = this.getItemByName(tree, item.title);
        if (file) {
          this.pics = file.children;
        }
      }

      // this.pics = [];
      // for (let i = 0; i < 15; i++) {
      //   this.pics.push({
      //     name: "军标" + (i + 1),
      //     code: i,
      //     url: "data/gg.svg",
      //   });
      // }
    },
    getItemByName(list, name) {
      if (!list) {
        return;
      }
      var item;
      for (var i = 0; i < list.length; i++) {
        var element = list[i];
        if (element.title == name) {
          item = element;
          return item;
        }
        item = this.getItemByName(element.children, name);
        if (item) {
          return item;
        }
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.title.indexOf(value) !== -1;
    },
  },
};
</script>

<style lang="scss" scoped>
.search-top {
  margin-bottom: 10px;
}

.tree-content {
  max-height: 30vh;
  overflow: auto;
  // border: solid 1px #e4e7ed;
}

.wrapper {
  margin-top: 20px;
  padding: 16px 16px 16px 16px;
  display: grid;
  grid-gap: 16px;
  // border: solid 1px #e4e7ed;
  border-top: 1px solid rgba(#fff, 0.2);
  max-height: 20vh;
  ;
  overflow-y: auto;
  overflow-x: hidden;
  grid-template: repeat(4, 1fr) / repeat(4, 1fr);
}

.item {
  text-align: center;
  border: 1px solid rgba(#fff, 0.5);
}
</style>

<style lang="scss">
.svgPlot-div {
  .el-input__inner {
    background-color: transparent !important;
    border: 1px solid rgba(#fff, 0.2);
    color: #ffffff;
  }

  .el-tree__empty-text {
    color: #ffffff;
  }

  .el-tree {
    background: none;
    color: #ffffff;
  }

  .el-tree-node__content:hover,
  .el-upload-list__item:hover {
    background-color: transparent !important;
    color: #83E9FF;
  }

  .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
    background-color: transparent !important;
    color: #83E9FF;
  }

  .el-tree-node:focus>.el-tree-node__content {
    background-color: transparent !important;
  }
}
</style>
